var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.32245 16.8889V8.44444H7.70612L8.03265 5.54921H5.3551V4.10159C5.3551 3.34331 5.42041 2.92971 6.53061 2.92971H8V0H5.61633C2.77551 0 1.76327 1.41315 1.76327 3.79138V5.54921H0V8.44444H1.76327V16.8889H5.32245Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"9","height":"17","viewBox":"0 0 9 17","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
